import log from "loglevel";

export const initLogger = () => {
    log.setLevel("debug", false);
};
